import React from "react"
import PropTypes from "prop-types"
import * as d3 from "d3"

const Line = ({ data, xAccessor, yAccessor, interpolation, style, ...props }) => {
    const lineGenerator = d3.line()
        .x(xAccessor)
        .y(yAccessor)
        .curve(interpolation)

    return (
        <path {...props}
              className={`Line`}
              d={lineGenerator(data)}
              style={style}
        />
    )
}

Line.propTypes = {
    data: PropTypes.array,
    interpolation: PropTypes.func,
}

Line.defaultProps = {
    interpolation: d3.curveLinear,
    style: {"stroke-dasharray": `1`}
}

export default Line
